// extracted by mini-css-extract-plugin
module.exports = {"videoProgress":"VideosEditorSlider-modulevideoProgress2Zi"};